export default "__VITE_ASSET__BdnvFQyZ__"